import { Box } from '@wix/design-system';
import { TrustBuilder } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { useIsStudioNewUi } from '../../hooks/useIsStudioNewUi';
import { RedesignedTrustBuilders } from './RedesignedTrustBuilders';
export { TRUST_BUILDERS_REDESIGN_DATA_HOOK, TRUST_BUILDER_PAYMENT_METHODS_DATA_HOOK, TRUST_BUILDER_MONEY_BACK_DATA_HOOK, TRUST_BUILDER_SSL_DATA_HOOK, TRUST_BUILDER_DIVIDER_DATA_HOOK } from './RedesignedTrustBuilders';
export const TrustBuilders = _ref => {
  let {
    align = 'left',
    padding
  } = _ref;
  const isStudioNewUi = useIsStudioNewUi();
  if (isStudioNewUi) {
    return /*#__PURE__*/React.createElement(RedesignedTrustBuilders, {
      padding: padding
    });
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    align: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(TrustBuilder.Root, null, /*#__PURE__*/React.createElement(TrustBuilder.Item.PaymentMethods, {
    align: align
  }), /*#__PURE__*/React.createElement(TrustBuilder.Item.MoneyBack, {
    align: align
  }), /*#__PURE__*/React.createElement(TrustBuilder.Item.Ssl, {
    align: align
  })));
};
//# sourceMappingURL=TrustBuilders.js.map